import type { AuthRealm } from "@/shared/auth/authRealm";
import { redirectToCognitoLogin } from "@/shared/auth/cognito";

type CognitoConfig = {
  cognitoDomain: string;
  clientId: string;
};

export async function startCognitoLogin(opts: {
  cognitoConfig: CognitoConfig;
  returnPath: string;
  forceLogin?: boolean;
  realm: AuthRealm;
}): Promise<void> {
  await redirectToCognitoLogin({
    cognitoDomain: opts.cognitoConfig.cognitoDomain,
    clientId: opts.cognitoConfig.clientId,
    redirectUri: `${window.location.origin}/callback`,
    state: opts.returnPath,
    prompt: opts.forceLogin ? "login" : undefined,
    realm: opts.realm,
  });
}
